module.exports = __webpack_public_path__ + "static/media/testing.e038b78f.jpg";